import React from 'react';
import LogoImg from '../assets/images/MMXLogo_150x150.png'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: `absolute`,
    left: 0,
    top: 0,
    background: '#383737',
    maxWidth: 80,
    minWidth: 80,
    height: '100%'
  },
  imagLogo: {
    backgroundImage: `url(${ LogoImg })`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 60,
    height: 60,
    margin: 'auto',
    marginTop: 20
  }
}));

function Logo(props) {
  const classes = useStyles(); 
  return(
    <div className={ classes.root }>
      <div className={ classes.imagLogo }></div>
    </div>
  )
}

export default Logo;